if (!customElements.get('product-media')) {
  customElements.define(
    'product-media',
    class ProductMedia extends HTMLElement {
      constructor() {
        super()
      }

      connectedCallback() {
        this.adjustSwiper()
      }

      adjustSwiper() {
        if (this.thumbnailSlider) {
          Object.assign(this.thumbnailSlider, {
            navigation: {
              enabled: true,
              nextEl: this.querySelector(`[data-direction='next']`),
              prevEl: this.querySelector(`[data-direction='prev']`),
            },
            on: {
              init() {
                setTimeout(() => {
                  document
                    .querySelector('.js-media-thumbnails-slider')
                    .classList.add('loaded')
                }, 200)
              },
            },
          })
          this.thumbnailSlider.initialize()
          this.thumbnailSlider
            .querySelectorAll('.js-thumbnail-item')
            .forEach((thumbnailItem, thumbnailIndex) => {
              thumbnailItem.addEventListener('keydown', (e) => {
                if (e.key !== 'Enter' && e.key !== ' ') return
                this.activeMedia(thumbnailIndex)
              })
            })
        }
        if (this.mainSlider) {
          this.mainSlider
            .querySelectorAll('swiper-slide')
            .forEach((element) => {
              element.classList.remove('hidden')
            })

          Object.assign(this.mainSlider, {
            injectStyles: [
              `
              .swiper-pagination {
                display: flex;
                justify-content: flex-start;
                padding: 0 12px;
                box-sizing: border-box;
              }

              .swiper-pagination-bullet {
                transition: width 0.2s;
              }

              .swiper-pagination-bullet-active {
                width: var(--swiper-pagination-active-bullet-width, var(--swiper-pagination-bullet-width, var(--swiper-pagination-bullet-size, 8px)));
              }

              ::slotted(.swiper-slide__deferred-media) {
                height: auto;
              }
            `,
            ],
            on: {
              slideChange() {
                this.slides.forEach((slide, index) => {
                  slide
                    .querySelectorAll('deferred-media')
                    .forEach((element) => {
                      if (index == this.realIndex) {
                        element.togglePlayer(false, false)
                      } else {
                        element.togglePlayer(true)
                      }
                    })
                })
              },
            },
            breakpoints: {
              990: {
                pagination: false,
              },
            },
          })

          this.mainSlider.initialize()
        }
      }

      get mainSlider() {
        return this.querySelector('.js-media-slider')
      }

      get thumbnailSlider() {
        return this.querySelector('.js-media-thumbnails-slider')
      }

      activeMedia(index) {
        this.mainSlider.swiper.slideTo(index)
      }
    }
  )
}
